import { client } from '../client';

export interface UnlockAccountPayload {
  email: string;
}

export interface UnlockAccountResponse {
  message: string;
}

export const unlockAccount = async (payload: UnlockAccountPayload): Promise<UnlockAccountResponse> => {
  const { data } = await client.post<UnlockAccountResponse>(`/auth/unlock_account`, payload);

  return data;
};
